module.exports = __webpack_public_path__ + "static/media/volume.79c146b8.svg";